// El rol tiene al menos un KPI o gráfica habilitado en "Permisos Dashboard B2B".
export function hasAnyPermission(state) {
    return !!state.dashboard
        && (Object.keys(state.dashboard.kpis || {}).length > 0 || Object.keys(state.dashboard.charts || {}).length > 0)
}
